<template>
  <div class="">
    <PreLoader v-if="isLoading" />

    <CustodyExpenseForm
      v-if="!isLoading"
      :custodyExpense="custodyExpense"
      v-on:addOrUpdateCustodyExpense="addOrUpdateCustodyExpense()"
      :submitName="$t('add')"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import { STATUS } from "@/utils/constants";
import CustodyExpenseForm from "@/components/settings/settingsOther/custodyExpenses/CustodyExpenseForm.vue";
import CustodyExpense from "@/models/settings/settingsOther/custodyExpenses/CustodyExpense";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  mixins: [createToastMixin],
  components: {
    PreLoader,
    CustodyExpenseForm,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      custodyExpense: new CustodyExpense(),
    };
  },
  methods: {
    async addOrUpdateCustodyExpense() {
      this.isLoading = true;
      try {
        let response = await this.custodyExpense.addOrUpdateCustodyExpense(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.custodyExpense.setInitialValue();
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {},
};
</script>
